import VodLogger from './logger'

VodLogger.TEA_ID = 1300
const xgVodLogger = function (args) {
  if (args && args.player) {
    const config = args.player.config.vodLogOpts || {}
    args.player.vodLogger = new VodLogger(args.player, config)
    args.player.plugins.xgVodLogger = args.player.vodLogger
  } else {
    this.vodLogger = new VodLogger(this, this.config.vodLogOpts || {})
  }
}
xgVodLogger.pluginName = '__xgVodLogger'
xgVodLogger.playerConfig = {}

export default xgVodLogger
